import { AccountApiUrls, ApiConfig, DeviceApiUrls, EShopApiUrls } from './types';

const devDiceApiBaseUrl: string =
    process.env.REACT_APP_DEV_API_BASE_URL || 'https://warpzone-api-dev.noa.nintendo.com';
const devNasApiUrl = `${devDiceApiBaseUrl}/emailornaid`;
const devDiceMulesoftProxyUrl = `${devDiceApiBaseUrl}/mulesoft-proxy`;
const devDiceGameplayProxyUrl = `${devDiceApiBaseUrl}/gameplay-proxy`;
const devNcomGraphUrl: string = process.env.NCOM_GRAPH_API_URL || 'https://graph.nintendo.com';

const devAccountApiUrls: AccountApiUrls = {
    accountAndDeviceDetails: (naid: string) => `${devDiceMulesoftProxyUrl}/account/${naid}`,
    gameRecommendations: (naid: string) => `${devDiceApiBaseUrl}/account/${naid}/recommendations`,
    gameSummaries: (naid: string) => `${devDiceGameplayProxyUrl}/${naid}`,
    gameSummaryDetails: (naid: string, applicationId: string) =>
        `${devDiceGameplayProxyUrl}/${naid}/title/${applicationId}`,
    partOrdersByNaid: (naid: string) =>
        `${devDiceApiBaseUrl}/partorders?naid=${naid}&sortOrder=desc`,
    partOrdersByEmail: (email: string) =>
        `${devDiceApiBaseUrl}/partorders?email=${email}&sortOrder=desc`,
    partOrdersByOrderNumber: (orderNumber: string) =>
        `${devDiceApiBaseUrl}/partorders?orderNumber=${orderNumber}`,
};

const devDeviceApiUrls: DeviceApiUrls = {
    associatedAccounts: (serialNumber: string) =>
        `${devDiceMulesoftProxyUrl}/v1_1/device/accounts/${serialNumber}`,
    deviceDetails: (serialNumber: string) =>
        `${devDiceMulesoftProxyUrl}/v1_1/device/${serialNumber}`,
    deviceRepairs: (serialNumber: string) =>
        `${devDiceMulesoftProxyUrl}/v1_1/device/repairs?serial_number=${serialNumber}&sort_order=desc&limit=3`,
    deviceRepairsByEmail: (email: string) =>
        `${devDiceMulesoftProxyUrl}/v1_1/device/repairs?email=${email}&sort_order=desc&limit=3`,
    errorCodes: () => `${devDiceMulesoftProxyUrl}/v1_1/device/error_codes`,
};

const devEShopApiUrls: EShopApiUrls = {
    purchaseHistory: (naid: string) => `${devDiceApiBaseUrl}/account/${naid}/purchase-history`,
};

export const devApiConfig: ApiConfig = {
    accountApiUrls: devAccountApiUrls,
    deviceApiUrls: devDeviceApiUrls,
    eShopApiUrls: devEShopApiUrls,
    nasUrl: devNasApiUrl,
    ncomGraphUrl: devNcomGraphUrl,
};
